var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroundingSystemActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#8FB16A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 78.7292C48.9808 78.7452 47.9751 78.4937 47.0833 78L46.2083 77.5042C39.3929 73.6482 33.7228 68.0526 29.7772 61.2887C25.8316 54.5247 23.7517 46.8348 23.75 39.0042V38.5959C23.7407 37.563 24.0059 36.5463 24.5183 35.6495C25.0308 34.7527 25.7721 34.0081 26.6667 33.4917L47.0833 22C47.9701 21.488 48.976 21.2185 50 21.2185C51.024 21.2185 52.0299 21.488 52.9167 22L73.3333 33.4917C74.2278 34.0081 74.9692 34.7527 75.4816 35.6495C75.9941 36.5463 76.2592 37.563 76.25 38.5959V39.0042C76.2424 46.8406 74.1538 54.5344 70.1976 61.2989C66.2414 68.0633 60.5596 73.6557 53.7333 77.5042L52.8583 78C51.9837 78.484 50.9995 78.735 50 78.7292ZM50 27.1042L29.5833 38.5959V39.0042C29.5882 45.8032 31.4004 52.4788 34.8342 58.347C38.268 64.2152 43.2 69.0651 49.125 72.4L50 72.8959L50.875 72.4C56.8 69.0651 61.732 64.2152 65.1658 58.347C68.5996 52.4788 70.4117 45.8032 70.4167 39.0042V38.5959L50 27.1042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1058 45.9707C59.0613 45.8792 58.9919 45.802 58.9055 45.748C58.8191 45.694 58.7192 45.6654 58.6173 45.6654H52.9608L57.4793 36.1446C57.5186 36.0621 57.5362 35.9709 57.5307 35.8797C57.5251 35.7885 57.4965 35.7002 57.4476 35.6229C57.3986 35.5457 57.3308 35.4821 57.2506 35.4381C57.1704 35.3941 57.0803 35.371 56.9887 35.3711H48.3031C48.1984 35.3711 48.0959 35.4013 48.008 35.4581C47.9201 35.5149 47.8506 35.5958 47.8077 35.6912L40.7507 51.4036C40.7136 51.4861 40.6978 51.5765 40.7047 51.6667C40.7116 51.7569 40.7411 51.8439 40.7903 51.9198C40.8396 51.9957 40.9071 52.0581 40.9867 52.1013C41.0663 52.1445 41.1555 52.1671 41.2461 52.1671H46.5438L43.9727 63.9715C43.9465 64.0912 43.9618 64.2163 44.016 64.3263C44.0703 64.4363 44.1603 64.5247 44.2714 64.5771C44.3825 64.6294 44.508 64.6426 44.6276 64.6145C44.7472 64.5863 44.8536 64.5186 44.9296 64.4222L59.0437 46.5426C59.1068 46.4627 59.146 46.3667 59.157 46.2656C59.168 46.1644 59.1502 46.0623 59.1058 45.9707Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundingSystemActive);
export default __webpack_public_path__ + "static/media/groundingSystemActive.dda1fbc1b912aca3232421348af9ff0f.svg";
export { ForwardRef as ReactComponent };